import React from "react";


const TPRMrecommendations = () => {
  document.title = "tprm-recommendations";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>tprm-recommendations</h1>
        
      </div>
    </React.Fragment>
  );
};

export default TPRMrecommendations;
